import { Box, Text, Tip } from 'grommet';
import { ComponentProps } from 'preact';

type TipProps = ComponentProps<typeof Tip>;

export interface TipContentProps {
  message: string;
}

export const TipContent = ({ message }: TipContentProps) => (
  <Box direction="row" align="center">
    <Box background="white" direction="row" pad="small" round="xsmall">
      <Text color="black">{message}</Text>
    </Box>
  </Box>
);

export interface TooltipProps extends TipProps {
  disabled?: boolean;
}

export const Tooltip = ({ disabled, children, ...tipProps }: TooltipProps) => {
  if (disabled) {
    return children;
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Tip {...(tipProps as TipProps)}>{children}</Tip>;
};
